// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"c50d6a2e","573":"29360e93","592":"4c7d70dd","805":"54ee3e9c"}[chunkId] + ".chunk.css";
};